import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Collapse,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    NavItem,
    NavLink,
    UncontrolledDropdown,
} from 'reactstrap';
import { Store } from './Store';
import { switchGroup } from './Actions';
import { saveSetting } from './components/TabsUserSetting';
import { isTest } from './mixins/EnvironmentMixin';
import { useAuthentication } from './authentication/authentication-hook';

const NavBar = ({ children }) => {
    const [ isOpen, setIsOpen ] = useState(true);

    const highlight = isTest();

    return (
        <Navbar
            color="dark"
            dark
            expand="md"
            className={ highlight ? 'navbar-test' : '' }
        >
            <NavbarBrand href="/">
                TOCC PMS { highlight && <span className="text-danger">{ ' ' }TEST</span> }
            </NavbarBrand>
            <NavbarToggler onClick={ () => setIsOpen(open => !open) } />
            <Collapse isOpen={ isOpen } navbar>
                { children }
            </Collapse>
        </Navbar>
    );
};

export function NavBarItems() {
    const {
        isAuthenticated,
    } = useAuthentication();

    const {
        state: {
            currentGroup,
            groups,
            user,
        },
        dispatch,
    } = useContext(Store);

    const toggleGroup = groupId => {
        switchGroup(groupId, dispatch);
        saveSetting(user, 'PMSGroup', groupId);
    };

    if (!isAuthenticated) {
        return null;
    }

    return (
        <>
            <Nav className="mr-auto" navbar>
                <NavItem>
                    <NavLink href="/" to="/">home</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink tag={ Link } to="/admin">admin</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink tag={ Link } to="/whatsnew">what's new?</NavLink>
                </NavItem>
            </Nav>
            <Nav className="ml-auto" navbar>
                { currentGroup && groups &&
                    <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret>
                            { currentGroup.name }
                        </DropdownToggle>
                        <DropdownMenu right>
                            { groups.map(group => {
                                return (
                                    <DropdownItem
                                        key={ group.id }
                                        onClick={ () => toggleGroup(group.id) }
                                    >
                                        { group.name }
                                    </DropdownItem>
                                );
                            }) }
                        </DropdownMenu>
                    </UncontrolledDropdown>
                }
                <NavItem>
                    <NavLink tag={ Link } to={ '/logout' }>
                        Log out { user.tabsusername ?? '' }
                    </NavLink>
                </NavItem>
            </Nav>
        </>
    );
}

export default React.memo(NavBar);
